import React from 'react';
import PropTypes from "prop-types";

const Area = (props) => {
    return (
        <div className={`area ${props.additionalClass}`} onClick={props.click}>
            <div className="area__inner">
                {props.children}
            </div>
        </div>
    );
};


export default Area;

Area.defaultProps = {
    additionalClass: '',
    click: () => {},
};

Area.propTypes = {
    additionalClass: PropTypes.string,
    click: PropTypes.func,
    children: PropTypes.node,
};


// WEBPACK FOOTER //
// ./sources/js/components/global/Area.js